import React from "react";

export const FilmFrontLogo = ({ size = "md", className = "" }) => {
  const sizes = {
    sm: { wrap: "text-sm", dot: "w-5 h-5" },
    md: { wrap: "text-base", dot: "w-6 h-6" },
    lg: { wrap: "text-2xl", dot: "w-8 h-8" },
    xl: { wrap: "text-4xl", dot: "w-10 h-10" },
  };
  const s = sizes[size] || sizes.md;
  return (
    <div className={`inline-flex items-center gap-2 font-display ${s.wrap} ${className}`} data-testid="film-front-logo">
      <div className={`relative ${s.dot} rounded-sm ff-accent-bg`}>
        <div className="absolute inset-[3px] bg-black" />
        <div className="absolute inset-0 border border-black/40" />
        <div className="absolute top-0 left-0 right-0 h-[3px] bg-black/60 flex">
          <span className="flex-1 border-r border-white/20" />
          <span className="flex-1 border-r border-white/20" />
          <span className="flex-1 border-r border-white/20" />
          <span className="flex-1" />
        </div>
        <div className="absolute bottom-0 left-0 right-0 h-[3px] bg-black/60 flex">
          <span className="flex-1 border-r border-white/20" />
          <span className="flex-1 border-r border-white/20" />
          <span className="flex-1 border-r border-white/20" />
          <span className="flex-1" />
        </div>
      </div>
      <span className="tracking-[0.2em] uppercase font-semibold text-white">
        FILM <span className="ff-accent-text">FRONT</span>
      </span>
    </div>
  );
};

export default FilmFrontLogo;
